import { AppInputSwitcher } from "../../components/Layouts/AppInputSwitcher/AppInputSwitcher";
import Grid from "@mui/material/Grid";
import AppCards from "../../components/UI/AppCards";
import React, { useEffect, useState } from "react";
import BookingApi from "../../API/Apis/BookingApi";
import { useNavigate } from "react-router-dom";
import AppButton, { AppStandardButton } from "../../components/UI/AppButtons";
import { t } from "i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState([]);
  const isDesktopScreen = window.innerWidth >= 1310;
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [shouldNavigate, setShouldNavigate] = useState(false); // New state to determine navigation
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
    if (shouldNavigate) {
      navigate("/updatePassword");
    }
  };

  const blurScreen = () => {
    document.body.style.opacity = String(0.5);
    document.body.style.pointerEvents = "none";
  };
  useEffect(() => {
    if (loading) {
      blurScreen();
    } else {
      document.body.style.opacity = String(1);
      document.body.style.pointerEvents = "";
    }
  }, [loading]);

  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: isDesktopScreen ? 450 : 760,
        },
      },
      targetOrigin
    );
  }
  useEffect(() => {
    requestParentResize();
  }, []);
  return (
    <div
      className="flex flex-col items-center h-screen justify-center"
      style={{ marginTop: isDesktopScreen ? "" : "" }}
    >
      <form
        className="w-full md:w-1/2"
        onSubmit={(e) => {
          e.preventDefault();
          setLoading(true);
          BookingApi.sentVerificationcode(email)
            .then((e) => {
              setLoading(false);
              if (e.status == "success") {
                console.log(e.status);
                setModalMessage("Email Sent Sucessfully");
                setShouldNavigate(true);
                setOpenModal(true);
              } else {
                setModalMessage("Email is not registered");
                setShouldNavigate(false);
                setOpenModal(true);
              }
              return e.data;
            })
            .catch((e) => {
              return e;
            });
        }}
        style={{ height: isDesktopScreen ? "" : "760px", maxWidth: "1462px" }}
      >
        <AppCards
          className="box-border p-4 min-h-[400px]"
          style={{
            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
            paddingTop: "69px",
          }}
        >
          <header
            className="flex flex-col gap-2 box-border py-5 ml-2 md:ml-[10%]"
            style={{ marginTop: isDesktopScreen ? "56px" : "34px" }}
          >
            <h2
              className="w-full  text-xl  text-[#FFFFFF] "
              style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
            >
              {t("Forgot Password")}?
            </h2>
            <p
              className="text-[#FFFFFF]"
              style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
            >
              {t(
                "A link to reset your password will be sent to the registered Email address"
              )}
            </p>
          </header>

          <Grid item xs={12} sm={6}>
            <AppInputSwitcher
              required={true}
              className={`ml-2 md:ml-[10%]   ${
                !isDesktopScreen ? "w-[94%]" : "w-[50%]"
              }`}
              containerheight={"36px"}
              containerwidth="100%" // Set both to 100% to align widths
              value={email}
              type="text"
              InputColor={true}
              label={t("Email Address")}
              key="email"
              showlabel={true}
              onchange={(v) => {
                setEmail(v);
              }}
              options={[]}
              variant="material"
            />
            <AppButton
              type={"submit"}
              className={`ml-2 md:ml-[10%]   ${
                !isDesktopScreen ? "w-[94%]" : "w-[50%]"
              }`}
              style={{ marginTop: "31px", background: "#0078D6" }}
            >
              <p className={`w-full text-center`}>{t("Submit")}</p>
            </AppButton>
          </Grid>
        </AppCards>
      </form>
      <Dialog
        open={openModal}
        onClose={requestOnClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { borderRadius: "20px" } }}
      >
        <DialogTitle style={{ padding: "3rem" }}>{modalMessage}</DialogTitle>

        <DialogActions style={{ justifyContent: "center" }}>
          <AppStandardButton variant="outlined" onClick={requestOnClose}>
            <p className="text-black normal-case">{t("Close")}</p>
          </AppStandardButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
